import { useMemo } from 'react'
import { Doughnut } from 'react-chartjs-2'
import type { ChartData, ChartOptions } from 'chart.js'
import { ensureChartsRegistered } from './register'
import { CATEGORY_PALETTE } from './palette'

ensureChartsRegistered()

export interface DoughnutChartProps {
  labels: string[]
  values: number[]
  colors?: readonly string[]
  cutout?: string
  height?: number | string
  className?: string
  ariaLabel?: string
}

export function DoughnutChart({
  labels,
  values,
  colors = CATEGORY_PALETTE,
  cutout = '75%',
  height = 220,
  className,
  ariaLabel,
}: DoughnutChartProps) {
  const data = useMemo<ChartData<'doughnut'>>(
    () => ({
      labels,
      datasets: [
        {
          data: values,
          backgroundColor: labels.map((_, i) => colors[i % colors.length]),
          borderWidth: 0,
        },
      ],
    }),
    [labels, values, colors],
  )

  const options = useMemo<ChartOptions<'doughnut'>>(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      cutout,
      plugins: {
        legend: { display: false },
        datalabels: { display: false },
      },
    }),
    [cutout],
  )

  return (
    <div
      className={className}
      style={{ height, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      role="img"
      aria-label={ariaLabel}
    >
      <Doughnut data={data} options={options} />
    </div>
  )
}
